import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import {
  TaskPage,
} from "../../components";
import styled from "styled-components";
import { useLocation } from 'react-router-dom';
import AutoScouterScoutingSession from '../AutoScouterDetail/AutoScouterScoutingSession';


const IdentifyRaces = () => {
  const [task, setTask] = useState(null);
  const [completionData, setCompletionData] = useState({});

  // get the pathname of the page
  const { pathname } = useLocation();
  const taskType = pathname.includes('identify-races') ? 'identify-races' : 'identify-measures';

  const completeButtonDisabled = !completionData?.autoScouterId || completionData?.autoScouterStatus !== 'completed';

  return (
    <Wrapper>
      <TaskPage
        taskType={taskType}
        completeButtonLabel='Mark complete'
        completeButtonDisabled={completeButtonDisabled}
        allowMultipleCheckedOutTasks
        holdingData={completionData}
        onCheckoutTask={(task) => {
          setTask(task);
          setCompletionData({});
        }}
        completionData={completionData}
        noMoreTasksMessage="There are currently no districts to identify ballot items for. Try back later."
        task={task}
      >
        {
          !task &&
          <Typography variant='body1'>Click a task on the left side pane to get started.</Typography>
        }
        {
          task &&
          <AutoScouterScoutingSession
            electionKey={task.details.election}
            districtId={task.details.district}
            showToolbar={false}
            createEntitiesTaskId={task?._id}
            onAutoScouterChange={(autoScouter) => {
              setCompletionData({
                autoScouterId: autoScouter?._id,
                scoutingConfirmed: Boolean(autoScouter?.review?.scouting),
                autoScouterStatus: autoScouter?.status
              });
            }}
            onScoutingConfirmed={(autoScouter) => {
              setCompletionData({
                autoScouterId: autoScouter?._id,
                scoutingConfirmed: true,
                autoScouterStatus: autoScouter?.status
              });
            }}
          />
        }
      </TaskPage>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: 100%;
`;



export default IdentifyRaces;
